import axios from "axios";
import Vue from "vue";

const URL = process.env.VUE_APP_API;

const FETCH_ALL_TESTS_SUCCESS = "FETCH_ALL_TESTS_SUCCESS";

const defaultState = {
  tests: [],
  loading: false,
  loading_recent: false,
};
const mutations = {
  [FETCH_ALL_TESTS_SUCCESS](state, payload) {
    Vue.set(state, "tests", payload);
  },
  setTestsLoading(state, val) {
    state.loading = val;
  },
  setLoadingRecent(state, val) {
    state.loading_recent = val;
  },
};

const actions = {
  async fetchAllTests({ commit }) {
    commit("setTestsLoading", true);
    commit("setLoadingRecent", true);
  
    try {
      const homepageRes = await axios.get(`${URL}/tests?homepage=1`);
      commit(FETCH_ALL_TESTS_SUCCESS, homepageRes.data.tests);
      commit("setLoadingRecent", false);
    } catch (e) {
      commit("setLoadingRecent", false);
      // You could optionally log or track the error here
    }
  
    try {
      const allTestsRes = await axios.get(`${URL}/tests`);
      commit(FETCH_ALL_TESTS_SUCCESS, allTestsRes.data.tests);
      commit("setTestsLoading", false);
      return allTestsRes.data.tests;
    } catch (e) {
      commit("setTestsLoading", false);
      return e;
    }
  
  },
};

const getters = {
  getTestsState: (state) => {
    return () => state;
  },
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
